import AppImagePicker from 'components/ImagePicker';
import AppFilePicker from 'components/ImagePicker/FilePicker';
import { AppTextArea, AppTextField, AppSwitchBox, AppButton } from 'components';
import * as AppPics from 'assets/images';
import ESDropDown from 'components/molecules/ESDropDown';
import ESTDropDown from 'components/molecules/ESTDropDown';
import { Fragment, useEffect, useState } from 'react';
import StatusDropDown from 'components/molecules/StatusDropDown';
import Joi from 'joi';
import { checkForErrors } from 'utilities/fns';
import ESSubjectDropDownMultiple from 'components/molecules/ESSubjectDropDownMultiple';
import usePlan from 'hooks/API/GET/usePlan';

import { Link } from 'react-router-dom';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
// import ChipInput from 'components/Inputs/ChipInput';
import classnames from 'classnames';
import ESClassDropDown from 'components/molecules/ESClassDropDown';
import useStatus from 'hooks/useStatus';

function ClassHandleSection({ handleClass, preloadedData = {}, editMode }) {
  const queryParams = `?mode=dropdown`;
  const enableAPI = true;
  const { data, isLoading } = usePlan({ enableAPI, queryParams });

  const [ES, handleES] = useState('');
  const [ESSubject, handleSubject] = useState([]);
  const [className, handleClassName] = useState('');
  const [country, handleCountry] = useState('');
  const [classOverview, handleClassOverview] = useState('');
  const [classContent, handleClassContent] = useState('');
  const [classID, handleClassID] = useState('');
  const [startDate, handleStartDate] = useState('');
  const [endDate, handleEndDate] = useState('');
  const [actualEndDate, handleActualEndDate] = useState('');
  const [specializations, setSpecializations] = useState([]);
  const [removedSpecs, setRemovedSpecs] = useState([]);
  const [classKey, handleClassKey] = useState('');
  const [status, handleStatus] = useStatus();
  const [formErrors, setFormErrors] = useState([]);
  const [availablePlans, setAvailablePlans] = useState([]);
  const [imageData, handleImageData] = useState(null);
  const [savedCourseImage, setCourseImage] = useState(null);
  const [savedSyllabus, setSyllabus] = useState(null);
  const [savedPromoVideo, setPromoVideo] = useState(null);
  const [disableSubmit, handleDisabling] = useState(false);
  const [pdfData, setPdfData] = useState(null);
  const [videoData, setVideoData] = useState(null);
  const [est, setEST] = useState(null);
  const [parentClass, setParentClass] = useState(false);
  const [classParent, setClassParent] = useState(null);
  // const [removedClassParent, setRemovedClassParent] = useState(null);

  // State for current active Tab
  const [currentActiveTab, setCurrentActiveTab] = useState('1');

  // Toggle active state for Tab
  const toggle = (tab) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  };

  function convertDate(inputFormat) {
    function pad(s) {
      return s < 10 ? `0${s}` : s;
    }
    const d = new Date(inputFormat);
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-');
  }
  useEffect(() => {
    if (isLoading) {
      return;
    }
    if (data && data.data && data.data.length) {
      const planDetails = [];
      data.data.map((pln) => {
        planDetails.push({
          name: pln.name,
          rate: 0,
          plan: pln._id,
        });
        return pln;
      });

      setAvailablePlans(planDetails);
    }
  }, [isLoading, data]);
  useEffect(() => {
    if (preloadedData?._id) {
      handleES(preloadedData?.es ?? '');
      setEST(preloadedData?.est ?? '');
      if (preloadedData && preloadedData.subjects) {
        const result = [];
        preloadedData.subjects.forEach((option) => {
          result.push({ value: option.subject._id, label: option.subject.name });
        });
        handleSubject(result);
      }
      handleClassName(preloadedData?.name ?? '');
      handleClassKey(preloadedData?.key ?? '');

      handleStartDate(convertDate(preloadedData.startDate));
      handleEndDate(convertDate(preloadedData.endDate));
      handleActualEndDate(convertDate(preloadedData.actualEndDate));
      if (preloadedData?.status) handleStatus(preloadedData?.status);
      setSpecializations(
        preloadedData?.specializations?.map?.((x) => ({ label: x.name, value: x._id })) ?? []
      );
      if (preloadedData?.planRates) {
        const planRates = preloadedData.planRates.map((planRt) => {
          return {
            name: (planRt.plan && planRt.plan.name) || '',
            plan: (planRt.plan && planRt.plan._id) || '',
            rate: planRt.rate,
          };
        });
        setAvailablePlans(planRates);
      }
      handleClassID(preloadedData?.classId);
      handleEST(preloadedData?.est);
      handleClassOverview(preloadedData?.classOverview);
      handleClassContent(preloadedData?.classContent);
      handleImageData({
        logoUrl: preloadedData?.courseImageUrl,
        imageUrl: preloadedData?.courseImageUrlFull,
      });
      setPdfData(preloadedData?.syllabusUrl);
      setVideoData(preloadedData?.promoUrl);
      setCourseImage(preloadedData?.courseImageUrlFull);
      setSyllabus(preloadedData?.syllabusUrlFull);
      setPromoVideo(preloadedData?.promoUrlFull);
      setParentClass(preloadedData?.isParentClass);
      setClassParent(preloadedData?.classParent);
    }
  }, [preloadedData]);

  function handleFormSubmission() {
    setFormErrors([]);

    const data = {
      name: className,
      key: classKey,
      subjects: ESSubject?.map?.((item) => item.value),
      startDate: startDate,
      endDate: endDate,
      actualEndDate: actualEndDate,
      es: ES,
      est: est,
      status,
      specializations: specializations.map((x) => x.value) || [],
      removedSpecs: removedSpecs.map((x) => x.value) || [],
      classID,
      classContent,
      classOverview,
      videoData: videoData?.meta?.file || preloadedData?.promoUrl,
      pdfData: pdfData?.meta?.file || preloadedData?.syllabusUrl,
      imageData: imageData?.logoUrl ?? null,
      planRates: availablePlans.map((item) => ({
        name: item.name,
        plan: item.plan,
        rate: item.rate,
      })),
      specializationChild: !!classParent,
      classParent,
      isParentClass: parentClass,
      // removedClassParent,
    };
    const validation = manageClassSchema.validate(data, { abortEarly: false, allowUnknown: true });

    if (validation?.error) {
      setFormErrors(validation.error?.details ?? []);
      return;
    }

    // console.log('API data :: ', data);
    handleClass(data);
  }
  const handleEST = (e) => {
    setEST(e);
  };

  const errors = checkForErrors(formErrors);

  return (
    <Fragment>
      <div className="addcoursesection">
        <Nav tabs className="tab__menu">
          <NavItem
            className={classnames({
              active: currentActiveTab === '1',
            })}
            onClick={() => {
              toggle('1');
            }}
          >
            Class Info
          </NavItem>
          <NavItem
            onClick={() => {
              toggle('2');
            }}
          >
            Class Timeline
          </NavItem>
          <NavItem
            className="lock"
            onClick={() => {
              toggle('3');
            }}
          >
            Class Audience
          </NavItem>
          <NavItem
            className="lock"
            onClick={() => {
              toggle('4');
            }}
          >
            Class Membership
          </NavItem>
          <NavItem
            className="lock"
            onClick={() => {
              toggle('5');
            }}
          >
            Class Analytics
          </NavItem>
        </Nav>
        <TabContent activeTab={currentActiveTab}>
          <TabPane tabId="1">
            <div className="tab__content">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <h2 className="prime-head p-0 boldtitle">
                      {editMode ? 'Edit Class' : 'Add Class'}
                    </h2>
                    <p className="text-muted">
                      {editMode ? 'Edit Class details here' : 'Add the Class details here'}
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="w-25 p-3">
                      <AppTextField
                        inputProps={{
                          value: className,
                          onChange: (event) => handleClassName(event.target.value),
                          placeholder: 'Class Name',
                        }}
                        labelProps={{ label: 'Class Name' }}
                        fieldErrors={errors['name']}
                      />
                    </div>
                    <div className="w-25 p-3">
                      <AppTextField
                        inputProps={{
                          value: classKey,
                          onChange: (event) => handleClassKey(event.target.value),
                          placeholder: 'Class Key',
                        }}
                        labelProps={{ label: 'Class Key' }}
                      />
                    </div>
                    <div className="w-25 p-3">
                      <ESTDropDown
                        enableAPI
                        value={est}
                        handleChange={(event) => setEST(event.target.value)}
                        fieldErrors={errors['es']}
                      />
                    </div>
                    <div className="w-25 p-3">
                      <ESDropDown
                        enableAPI={!!est}
                        dependencies={{
                          query: est ? `est=${est}` : ``,
                        }}
                        value={ES}
                        handleChange={(event) => handleES(event.target.value)}
                        fieldErrors={errors['es']}
                        defaultLook={false}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12  col-sm-12"></div>
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="w-25 p-3">
                      <AppTextField
                        inputProps={{
                          value: classID,
                          onChange: (event) => handleClassID(event.target.value),
                          placeholder: 'Class ID',
                        }}
                      />
                    </div>
                    <div className="w-25 p-3 ">
                      <AppTextArea
                        areaProps={{
                          value: classContent,
                          onChange: (event) => handleClassContent(event.target.value),
                          placeholder: 'Class Contents',
                        }}
                        label="Class Contents"
                        fieldErrors={errors['classContent']}
                      />
                    </div>
                    <div className="w-25 p-3">
                      <AppTextArea
                        areaProps={{
                          value: classOverview,
                          onChange: (event) => handleClassOverview(event.target.value),
                          placeholder: 'Class Overview',
                        }}
                        label="Class Overview"
                        fieldErrors={errors['classOverview']}
                      />
                    </div>
                    <div className="w-25 p-3 disinline imgupload">
                      <span className="w-100 label">Class Image</span>
                      <AppImagePicker
                        image={imageData?.imageUrl}
                        handleChange={(imageData) => handleImageData(imageData)}
                        handleDisabling={(doDisable) => handleDisabling(doDisable)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 row">
                    <div className="col-lg-4 mt-4 align-center">
                      <AppFilePicker
                        text="Class Promo Video"
                        inputProps={{ accept: '.mp4' }}
                        handleChange={(data) => setVideoData(data)}
                      />
                    </div>
                    <div className="col-lg-4 mt-4 align-center">
                      <AppFilePicker
                        text="Specification/Syllabus"
                        inputProps={{ accept: '.pdf' }}
                        handleChange={(data) => setPdfData(data)}
                      />
                    </div>
                  </div>
                </div>
                <div className="row mt-5 btnsubmitmain pb-3">
                  <div className="col-12 btnTab-foot d-flex justify-content-end">
                    <AppButton variantClass="btn-primary mx-3" onClick={handleFormSubmission}>
                      Save Changes
                    </AppButton>
                  </div>
                </div>
              </div>
            </div>
          </TabPane>
          <TabPane tabId="2">
            <Row>
              <Col sm="12">
                <h5>Sample Tab 2 Content</h5>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="3">
            <Row>
              <Col sm="12">
                <h5>Sample Tab 3 Content</h5>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </div>
    </Fragment>
  );
}

ClassHandleSection.defaultProps = {
  handleClass: () => {},
};

const manageClassSchema = Joi.object({
  es: Joi.string().required(),
  //class: Joi.string().required(),
  name: Joi.string().required().min(1),
});

export default ClassHandleSection;
